module.exports = __webpack_public_path__ + "img/temporizadores_industriales.9058ed2b.jpg";